import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Stepper from "../components/Stepper";
import "./WorkerDashboard.css";
import axios from "axios";
import { Helmet } from "react-helmet-async";


const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://lucky-adaptation-production-1a1b.up.railway.app";



const getInitials = (name) => {
  if (!name) return "W";

  const parts = name.trim().split(" ");

  const first = parts[0];
  const last = parts[parts.length - 1];

  return (first[0] + last[0]).toUpperCase();
};

const getNotifications = (application) => {
  if (!application?.application) return [];

  const status = application.application.status;

  

  switch (status) {

    case "SUBMITTED":
      return [
        {
          id: 0,
          message:
            "Your entry permit application has been submitted by your sponsor. Application will be reviewed in due time.",
          type: "info",
        },
      ];

    case "PRE_AUTHORIZED":
      return [
        {
          id: 1,
          message: "Your entry permit application has been pre-authorized. Please complete IMC payment.",
          type: "warning",
        },
      ];

    case "IHC_REQUIRED":
      return [
        {
          id: 2,
          message: "Payment received. Proceed to medical examination.",
          type: "success",
        },
      ];

    case "under_review":
      return [
        {
          id: 3,
          message: "Your entry permit application is under review. Please wait for approval.",
          type: "info",
        },
      ];

      

    default:
      return [];
  }
};


const WorkerDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const menuRef = useRef();
  const [darkMode, setDarkMode] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showNotif, setShowNotif] = useState(false);
  const [loading, setLoading] = useState(true);
  
  

  let data = location.state;

  if (!data) {
    const stored = localStorage.getItem("workerData");
    data = stored ? JSON.parse(stored) : null;
  }

  const [application, setApplication] = useState(data || {});

  console.log("Stored data:", localStorage.getItem("workerData"));
  

  useEffect(() => {
  const fetchApplication = async () => {
    try {
      const storedData = JSON.parse(localStorage.getItem("workerData"));

      if (!storedData) {
        console.warn("No stored data");
        setLoading(false); // ✅ FIX
        return;
      }

      const reference =
        storedData?.application?.reference ||
        storedData?.reference ||
        storedData?.reference_number;

      if (!reference) {
        console.warn("No reference found");
        setLoading(false); // ✅ FIX
        return;
      }

      const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://lucky-adaptation-production-1a1b.up.railway.app";

      const res = await axios.get(
       `${API_URL}/api/workers/application/reference/${reference}`
      );
      console.log("🌐 FULL RESPONSE:", res);

      // 🚨 BLOCK BAD RESPONSE
      if (!res.data || typeof res.data !== "object") {
        console.error("❌ BAD RESPONSE URL:", res.config.url);
  console.error("❌ RESPONSE:", res.data);
        setLoading(false); // ✅ FIX
        return;
      }

      setApplication(res.data);
      localStorage.setItem("workerData", JSON.stringify(res.data));

    } catch (err) {
      console.error("API error:", err);
    } finally {
      setLoading(false); // ✅ ALWAYS RUNS
    }
  };

  fetchApplication();
}, []);

  useEffect(() => {
  if (!application?.application?.status) return;

  const newNotifs = getNotifications(application);

  setNotifications((prev) => {
    const existingIds = prev.map((n) => n.id);

    // Only add new ones not already in state
    const filtered = newNotifs.filter(
      (n) => !existingIds.includes(n.id)
    );

    return [...prev, ...filtered];
  });
}, [application?.application?.status]);



  const handleRead = (id) => {
  // mark as read (fade out after 2s)
  setNotifications((prev) =>
    prev.map((n) =>
      n.id === id ? { ...n, removing: true } : n
    )
  );

  setTimeout(() => {
    setNotifications((prev) =>
      prev.filter((n) => n.id !== id)
    );
  }, 2000); // ⏳ countdown
};

 


  // ✅ Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  // ✅ Logout handler
  const handleLogout = () => {
    localStorage.removeItem("workerData");
    navigate("/workerverify");
  };

  
  const statusMap = {
    submitted: 0,
    under_review: 1,
    PRE_AUTHORIZED: 2,
    PAYMENT_PENDING: 3,
    IMC_REQUIRED: 4,
    medical_done: 4,
    approved: 5,
  };



if (loading) {
  return <div>Loading dashboard...</div>;
}

if (!application?.application) {
  return <div>No application data found</div>;
}

console.log("FULL APPLICATION:", application);
console.log("APPLICATION OBJECT:", application.application);

 return (
  <div className={`dashboard-container ${darkMode ? "dark" : ""}`}>

    <Helmet>
  <title>LMRA - Worker Dashboard</title>
</Helmet>


     {/* 🔷 TOP BAR (SAME AS VERIFY) */}
    <div className="top-bar">

   

  {/* LEFT */}
  <div className="top-left">
    Worker Dashboard &nbsp; || &nbsp;
    Welcome: {application?.worker?.name || "Worker"}
  </div>


   
  {/* RIGHT (🔥 NEW) */}
  <div className="top-right">

    {/* 🌙 Dark Mode */}
    <button
      className="dark-toggle"
      onClick={() => setDarkMode(!darkMode)}
    >
      {darkMode ? "☀️" : "🌙"}
    </button>

    {/* 🔔 Notification */}
    <div
      className="notification"
      onClick={() => setShowNotif(!showNotif)}
    >
      🔔
      {notifications.length > 0 && (
        <span className="badge">{notifications.length}</span>
      )}

      {showNotif && (
        <div className="notif-dropdown">
          {notifications.length === 0 ? (
            <p className="empty">No notifications</p>
          ) : (
            notifications.map((n) => (
              <div
                key={n.id}
                className={`notif-item ${n.type}`}
                onClick={() => handleRead(n.id)}
              >
                {n.message}
              </div>
            ))
          )}
        </div>
      )}
    </div>

    

    {/* 🟡 STATUS */}
    <span className={`status-badge ${application.application?.status}`}>
      {application.application?.status || "N/A"}
    </span>

    {/* 👤 AVATAR */}
    <div className="avatar-wrapper" ref={menuRef}>
      <div
        className="avatar small"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {getInitials(application?.worker?.name)}
      </div>

      <div className={`dropdown-menu ${menuOpen ? "open" : ""}`}>
        <div className="dropdown-header">
          <div className="avatar small">
            {getInitials(application?.worker?.name)}
          </div>
          <div>
            <p className="dropdown-name">
              {application?.worker?.name || "Worker"}
            </p>
            <span className="dropdown-sub">{application?.worker?.name || "Worker"}</span>
          </div>
        </div>

    
        <button
          className="dropdown-item"
          onClick={() => {
            setShowProfile(true);
            setMenuOpen(false);
          }}
        >
          👤 Profile
        </button>

        <button className="dropdown-item">⚙️ Settings</button>

        <button
          onClick={handleLogout}
          className="dropdown-item logout"
        >
          🚪 Logout
        </button>
      </div>
    </div>

    {/* Help */}
    <span className="help-link">Help</span>

  </div>
</div>

<div className="header-banner">
  <img src="/assets/banner.png" alt="LMRA Header" />
</div>
    

    {/* 👤 PROFILE MODAL */}
{showProfile && (
  <div
    className="modal-overlay"
    onClick={() => setShowProfile(false)}
  >
    <div
      className="modal-card"
      onClick={(e) => e.stopPropagation()}
    >

      {/* 🔴 AVATAR SECTION */}
      <div className="profile-avatar">
        {getInitials(application?.worker?.name)}
      </div>

      <h3>Profile</h3>

      <p><strong>Name:</strong> {application.worker?.name}</p>
      <p><strong>Passport:</strong> {application.worker?.passport}</p>
      <p><strong>Permit ID:</strong> {application.application?.reference}</p>
      <p><strong>Status:</strong> {application.application?.status}</p>

      <button onClick={() => setShowProfile(false)}>
        Close
      </button>
    </div>
  </div>
)}

      {/* Info Cards */}
      <div className="info-grid">

        <div className="info-card">
          <p className="label">Worker Name</p>
          <p className="value">
            {application?.worker?.name || "N/A"}
          </p>
        </div>

        {/* IHC */}
        <div className="ihc-card">
          <h3>IMC Payment</h3>

          <p>
            <strong>Status:</strong>{" "}
            <span className={`ihc-status ${application.ihc?.payment_status}`}>
              {application.ihc?.payment_status || "NOT GENERATED"}
            </span>
          </p>

          <p>
            <strong>Amount:</strong>{" "}
            {application.ihc?.fee ? `BHD ${application.ihc.fee}` : "N/A"}
          </p>

<div className="ihc-actions">

  {application.application?.invoice_uploaded ? (

 <a
  href={`${application.application?.invoice_url}?fl_attachment=invoice.pdf`}
  target="_blank"
  rel="noopener noreferrer"
>
  <button className="btn-success">
    Download Invoice
  </button>
</a>

  ) : application.ihc?.payment_status === "PAID" ? (

    <button className="btn-success">
      View Receipt
    </button>

  ) : application.application?.status === "PRE_AUTHORIZED" ? (

    <button
      className="btn-primary"
      onClick={() =>
        navigate("/help", { state: application })
      }
    >
      Pay Now
    </button>

  ) : application.application?.status === "PAYMENT_PENDING" ? (

    <button className="btn-disabled" disabled>
      Invoice Requested
    </button>

  ) : (

    <button disabled>No Action</button>

  )}

</div>
</div>

        <div className="info-card">
          <p className="label">Permit ID</p>
          <p className="value">
            {application.application?.reference || "N/A"}
          </p>
        </div>

        <div className="info-card">
          <p className="label">Sponsor</p>
          <p className="value">
            {application.employer?.company_name || "N/A"}
          </p>
        </div>

      </div>

      {/* Stepper */}
      <div className="stepper-section">
        <h3>Application Progress</h3>
        <Stepper
          currentStep={
            statusMap[application.application?.status] || 0
          }
        />
      </div>

    </div>
  );
};

export default WorkerDashboard;
